import { GetForeignUserListResponse } from '@/services';

import { formatDate, map } from 'utils';

export const formatForeignUserDetail = (
	input: GetForeignUserListResponse['content'][number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};

export const formatForeignUserList = (
	input: GetForeignUserListResponse['content']
) => {
	return map(input, formatForeignUserDetail);
};
